<template>
  <div class="v2-cart-error-popup">
    <button
      class="v2-cart-error-popup__close"
      @click="$emit('on-cross-icon-click')"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <line
          x1="18"
          y1="6"
          x2="6"
          y2="18"
        />
        <line
          x1="6"
          y1="6"
          x2="18"
          y2="18"
        />
      </svg>
    </button>
    <div class="v2-cart-error-popup__content">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="var(--v2-destructive)"
        stroke-width="2"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
        />
        <line
          x1="12"
          y1="8"
          x2="12"
          y2="12"
        />
        <line
          x1="12"
          y1="16"
          x2="12.01"
          y2="16"
        />
      </svg>
      <span class="v2-cart-error-popup__title">{{ errorTitle }}</span>
    </div>
    <button
      v-if="shouldShowRemoveAllBtn"
      class="v2-cart-error-popup__remove-btn"
      :disabled="isRemovingItems"
      @click="$emit('on-remove-all-click')"
    >
      {{ isRemovingItems ? 'Removing...' : removeAllBtnTitle }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'V2CartErrorPopup',
  props: {
    errorTitle: {
      type: String,
      default: 'Some items have errors',
    },
    removeAllBtnTitle: {
      type: String,
      default: 'Remove all',
    },
    isRemovingItems: {
      type: Boolean,
      default: false,
    },
    shouldShowRemoveAllBtn: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['on-cross-icon-click', 'on-remove-all-click'],
}
</script>

<style lang="scss" scoped>
.v2-cart-error-popup {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background-color: #fef2f2;
  border: 1px solid var(--v2-destructive);
  border-radius: var(--v2-radius);
  margin-bottom: 0.5rem;

  &__close {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    color: var(--v2-muted-foreground);
    flex-shrink: 0;
  }

  &__content {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 1;
  }

  &__title {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--v2-destructive);
  }

  &__remove-btn {
    background: none;
    border: 1px solid var(--v2-destructive);
    border-radius: var(--v2-radius);
    color: var(--v2-destructive);
    padding: 0.25rem 0.75rem;
    font-size: 0.75rem;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;

    &:hover {
      background-color: var(--v2-destructive);
      color: white;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>
